/**
 * An enumeration of different actions a user is allowed to perform. User access rules are defined for every route in
 * {@link AppRoutingModule}.
 */
export enum Authority {
  /** User can access all stores in the system. */
  AUTH_SEE_ALL_STORES = 'AUTH_SEE_ALL_STORES',

  /** User can see some specific stores, assigned separately. */
  AUTH_SEE_SPECIFIC_STORES = 'AUTH_SEE_SPECIFIC_STORES',

  /** User can see footfall and required employees predictions for a store. */
  AUTH_SEE_PREDICTIONS = 'AUTH_SEE_PREDICTIONS',

  /** User can see rotas for a store. */
  AUTH_SEE_ROTAS = 'AUTH_SEE_ROTAS',

  /** User can initiate a rerun of rota regeneration. */
  AUTH_REGENERATE_ROTAS = 'AUTH_REGENERATE_ROTAS',

  /** User can see the employee information for a store. */
  AUTH_SEE_EMPLOYEES = 'AUTH_SEE_EMPLOYEES',

  /** User can see the working times for a store. */
  AUTH_SEE_TRADING_TIMES = 'AUTH_SEE_TRADING_TIMES',

  /** User can see the minimum employee requirements for a store. */
  AUTH_SEE_STORE_REQUIREMENTS = 'AUTH_SEE_STORE_REQUIREMENTS',

  /** User can see banking requirements for a store. */
  AUTH_SEE_STORE_BANKING = 'AUTH_SEE_STORE_BANKING',

  /** User can see store closures. */
  AUTH_SEE_STORE_CLOSED = 'AUTH_SEE_STORE_CLOSED',

  /** User can see information about other users. */
  AUTH_SEE_USERS = 'AUTH_SEE_USERS',

  /** User can manage other users' access to the system. */
  AUTH_MANAGE_USER_ACCESS = 'AUTH_MANAGE_USER_ACCESS',

  /** User can manage other users' access to specific stores. */
  AUTH_MANAGE_USER_STORE_ACCESS = 'AUTH_MANAGE_USER_STORE_ACCESS',

  /** User can perform administration tasks. */
  AUTH_PERFORM_ADMINISTRATION = 'AUTH_PERFORM_ADMINISTRATION'
}

/**
 * An enumeration of different actions a user group is allowed to perform.
 */
export enum AccessRules {
  /** User group can access all stores in the system. */
  SEE_ALL_STORES = 'SEE_ALL_STORES',

  /** User group can see some specific stores, assigned separately. */
  SEE_SPECIFIC_STORES = 'SEE_SPECIFIC_STORES',

  /** User group can see footfall and required employees predictions for a store. */
  SEE_PREDICTIONS = 'SEE_PREDICTIONS',

  /** User group can see rotas for a store. */
  SEE_ROTAS = 'SEE_ROTAS',

  /** User group can initiate a rerun of rota regeneration. */
  REGENERATE_ROTAS = 'REGENERATE_ROTAS',

  /** User group can see the employee information for a store. */
  SEE_EMPLOYEES = 'SEE_EMPLOYEES',

  /** User group can see the working times for a store. */
  SEE_TRADING_TIMES = 'SEE_TRADING_TIMES',

  /** User group can see the minimum employee requirements for a store. */
  SEE_STORE_REQUIREMENTS = 'SEE_STORE_REQUIREMENTS',

  /** User group can see banking requirements for a store. */
  SEE_STORE_BANKING = 'SEE_STORE_BANKING',

  /** User group can see store closures. */
  SEE_STORE_CLOSED = 'SEE_STORE_CLOSED',

  /** User group can see information about other users. */
  SEE_USERS = 'SEE_USERS',

  /** User group can manage other users' access to the system. */
  MANAGE_USER_ACCESS = 'MANAGE_USER_ACCESS',

  /** User group can manage other users' access to specific stores. */
  MANAGE_USER_STORE_ACCESS = 'MANAGE_USER_STORE_ACCESS'
}
